export default {
  init() {
    // JavaScript to be fired on all pages
    jQuery(function ($) {
      var lightbox = lity();
      console.log('loaded home javascript');
      $(document).on('click', '[data-lightbox]', lightbox);
      $(document).on('lity:open', function () {
        $("body").on('scroll mousewheel touchmove', function (e) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        });
      });
      $(document).on('lity:close', function () {
        $("body").unbind('scroll mousewheel touchmove');
      });
    });
    jQuery(function ($) {
      $(document).on('click', 'a:not(.bypass)', function (e) {
        var href = $(this).attr('href');
        if (!/(.*)(afrcorp.com|afrwholesale.com|renovationshome.com|afrloancenter.com|elend.com|myloancenter.com|youtube.com\/embed)/.test(href) && href.charAt(0) !== '/' && href.charAt(0) !== '#' && href.substring(0, 4) !== 'tel:' && href.substring(0, 7) !== 'mailto:') {
          e.preventDefault();
          $('#privacy-external-link').attr('href', href);
          $('#privacy-external-link').text(href);
          $('#procede-link').attr('href', href);
          $('#privacy-disclaimer-modal').modal('show');
        }
        $('.bypass').click(function () {
          $('#privacy-disclaimer-modal').modal('hide');
        });
      });
    });
    jQuery(function ($) {
      $(".scroll").click(function (event) {
        event.preventDefault();
        //calculate destination place
        var dest = 0;
        if ($(this.hash).offset().top > $(document).height() - $(window).height()) {
          dest = $(document).height() - $(window).height();
        } else {
          dest = $(this.hash).offset().top;
        }
        //go to destination
        $('html,body').animate({ scrollTop: dest }, 1000, 'swing');
      });
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js